export default {
  partNoPlaceholder: 'Vybrať číslo dielu',
};
